import { render, staticRenderFns } from "./AdminCreateAnswersFiles.vue?vue&type=template&id=27b34403&scoped=true"
import script from "./AdminCreateAnswersFiles.vue?vue&type=script&lang=js"
export * from "./AdminCreateAnswersFiles.vue?vue&type=script&lang=js"
import style0 from "./AdminCreateAnswersFiles.vue?vue&type=style&index=0&id=27b34403&lang=css"
import style1 from "./AdminCreateAnswersFiles.vue?vue&type=style&index=1&id=27b34403&scoped=true&lang=css"
import style2 from "./AdminCreateAnswersFiles.vue?vue&type=style&index=2&id=27b34403&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b34403",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27b34403')) {
      api.createRecord('27b34403', component.options)
    } else {
      api.reload('27b34403', component.options)
    }
    module.hot.accept("./AdminCreateAnswersFiles.vue?vue&type=template&id=27b34403&scoped=true", function () {
      api.rerender('27b34403', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminCreateAnswersFiles.vue"
export default component.exports